import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import Link from 'next/link'
import dynamic from 'next/dynamic'
const PricingIllustration = dynamic(
  () => import('@public/static/vectorIllustrations/pricingIllustration')
)
const WhatIsEdugramIllustration = dynamic(
  () => import('@public/static/vectorIllustrations/whatIsEdugramIllustration')
)
const OurAdvantageousIllustration = dynamic(
  () => import('@public/static/vectorIllustrations/ourAdvantageousIllustration')
)
import { useTranslation } from 'react-i18next'

type Props = {
  className?: string
}

const Explore = ({ className = '' }: Props) => {
  const { t } = useTranslation('advantageous')

  const data = [
    {
      icon: WhatIsEdugramIllustration,
      title: t('explore.item1_title', { ns: 'advantageous' }),
      url: '/',
    },
    {
      icon: PricingIllustration,
      title: t('explore.item2_title', { ns: 'advantageous' }),
      url: '/pricing/',
    },
    {
      icon: OurAdvantageousIllustration,
      title: t('explore.item3_title', { ns: 'advantageous' }),
      url: '/our-advantageous/',
    },
  ]

  return (
    <Container className={className}>
      <Wrapper>
        <Header>{t('explore.header', { ns: 'advantageous' })}</Header>
        <Content>
          {data.map((item, index) => (
            <motion.div
              key={`${item.title}-${index}`}
              whileHover={{
                transform: 'scale(1.1) translateZ(0)',
              }}
              transition={{
                duration: 0.2,
              }}
              className="w-full xs:w-auto"
              style={{
                transform: 'translateZ(0)',
              }}
            >
              {item.url ? (
                <Link href={item.url}>
                  <ContentItem>
                    <div className="mt-[48px] relative min-h-[267px] min-w-[268px]">
                      <div className="w-[90%] h-[90%] blur-md bg-opacity-[0.2] bg-white z-[0] " />
                      <span className="absolute m-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <item.icon />
                      </span>
                    </div>
                    <ContentItemTitle>{item.title}</ContentItemTitle>
                  </ContentItem>
                </Link>
              ) : (
                <ContentItem>
                  <div className="mt-[48px] relative min-h-[267px] min-w-[268px]">
                    <div className="w-[90%] h-[90%] blur-md bg-opacity-[0.2] bg-white z-[0] " />
                    <span className="absolute m-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                      <item.icon />
                    </span>
                  </div>
                  <ContentItemTitle>{item.title}</ContentItemTitle>
                </ContentItem>
              )}
            </motion.div>
          ))}
        </Content>
      </Wrapper>
    </Container>
  )
}

export default Explore

const Container = styled.div`
  min-height: 870px;
  margin-bottom: ${(props) =>
    props.bottomPadding ? props.bottomPadding : '6rem'};
`
const Wrapper = styled.div`
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`
const Header = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-weight: 600;
  text-align: center;
  color: ${colors.uguPurple};
  margin: 6rem 0rem;
  font-size: 5rem;
  line-height: 5rem;
  @media screen and (max-width: 1024px) {
    line-height: 4rem;
    font-size: 4rem;
  }
  @media screen and (max-width: 596px) {
    font-size: 36px;
    line-height: 36px;
    margin: 48px 0rem;
  }
`
const Content = styled.div`
  display: flex;
  gap: 48px;
  flex-wrap: wrap;
  justify-content: space-evenly;
  max-width: 1440px;
  margin: 0px auto;
  @media screen and (max-width: 386px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
`
const ContentItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 376px;
  background-color: #7181ff40;
  padding: 0, 48px, 72px, 48px;
  border-radius: 50px;
  gap: 32px;
  height: 456px;
  cursor: pointer;
  @media screen and (max-width: 396px) {
    width: auto;
    padding: 0 2rem 72px 2rem;
  }
`
const ContentItemTitle = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  color: ${colors.uguPurple};
`
